import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import $ from "jquery";
import InputHelpers from "../../utils/InputHelpers";


class ProfileCreateView extends React.Component {

    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        googleAPILibReady: PropTypes.bool.isRequired,
        displayName: PropTypes.object.isRequired,
        email: PropTypes.object.isRequired,
        phoneNumber: PropTypes.object.isRequired,
        about: PropTypes.object.isRequired,
        paymentAddressName: PropTypes.object.isRequired,
        currentPaymentAddressGooglePlaceId: PropTypes.object.isRequired,
        currentPaymentAddressStreetNumber: PropTypes.string.isRequired,
        currentPaymentAddressRoute: PropTypes.string.isRequired,
        currentPaymentAddressSecondaryAddress: PropTypes.object.isRequired,
        currentPaymentAddressLocality: PropTypes.string.isRequired,
        currentPaymentAddressAdministrativeAreaLevel1: PropTypes.string.isRequired,
        currentPaymentAddressAdministrativeAreaLevel2: PropTypes.string.isRequired,
        currentPaymentAddressCountryLong: PropTypes.string.isRequired,
        currentPaymentAddressCountryShort: PropTypes.string.isRequired,
        currentPaymentAddressPostalCode: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.autocomplete = null;
        this.formSubmitRef = React.createRef();
    }

    componentDidMount() {
        const elem = document.getElementById("inputPaymentAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            this.attachGoogleAPI(elem)
        }
        $('[data-toggle="tooltip"]').tooltip()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const elem = document.getElementById("inputPaymentAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            this.attachGoogleAPI(elem)
        }
    }

    componentWillUnmount() {
        const elem = document.getElementById("inputPaymentAddress");
        if (elem !== null && this.props.googleAPILibReady) {
            window.google.maps.event.removeListener(this.autocompleteEventListener);
        }
        if (elem !== null) {
            elem.remove()
        }
    }

    attachGoogleAPI(elem) {
        this.autocomplete =
            new window.google.maps.places.Autocomplete(
                elem,
                {
                    types: ["address"]
                });
        this.autocomplete.setFields(["address_component", "place_id"]);
        this.autocompleteEventListener =
            this.autocomplete.addListener(
                "place_changed",
                () => {
                    if(this.autocomplete.getPlace() !== undefined) {
                        console.log("Place Selected", this.autocomplete.getPlace());
                        EventPublisher.publish(
                            UIInteractionEvents.PROFILE_CREATE_ADDRESS_AUTOCOMPLETE_CHANGED,
                            {
                                "address": this.autocomplete.getPlace(),
                                "isValid": document.getElementById("inputPaymentAddress").checkValidity()
                            });
                    }
                });
    }

    handleDisplayNameChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_DISPLAY_NAME_CHANGED,
            {
                displayName: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleEmailChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_EMAIL_CHANGED,
            {
                email: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handlePhoneNumberChanged = (value) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_PHONE_NUMBER_CHANGED,
            {
                phoneNumber: value,
                isValid: document.getElementById("inputPhoneNumber").checkValidity()
            });
    };

    handleAboutChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_ABOUT_CHANGED,
            {
                about: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handlePaymentAddressNameChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_PAYMENT_ADDRESS_NAME_CHANGED,
            {
                paymentAddressName: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleCurrentPaymentAddressSecondaryAddressChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.PROFILE_CREATE_SECONDARY_ADDRESS_CHANGED,
            {
                currentPaymentAddressSecondaryAddress: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.everythingIsValid()) {
            EventPublisher.publish(
                UIInteractionEvents.PROFILE_CREATE_SAVE_SUBMITTED,
                {
                    displayName: this.props.displayName.currentValue,
                    email: this.props.email.currentValue,
                    phoneNumber: this.props.phoneNumber.currentValue,
                    about: this.props.about.currentValue,
                    paymentAddressName: this.props.paymentAddressName.currentValue,
                    currentPaymentAddressGooglePlaceId: this.props.currentPaymentAddressGooglePlaceId.currentValue,
                    currentPaymentAddressSecondaryAddress: this.props.currentPaymentAddressSecondaryAddress.currentValue
                }
            );
        }
        // this.formSubmitRef.current.classList.add("was-validated");
    };

    everythingIsValid() {
        return this.props.displayName.isValid && this.props.displayName.isUnique &&
            this.props.email.isValid && this.props.displayName.isUnique &&
            this.props.phoneNumber.isValid &&
            this.props.about.isValid &&
            this.props.currentPaymentAddressGooglePlaceId.isValid &&
            this.props.currentPaymentAddressSecondaryAddress.isValid &&
            this.props.paymentAddressName.isValid;
    }

    generateClassNameWithValidityForFormFieldWithValidState(defaultClassName, formFieldWithValidityState) {
        if (formFieldWithValidityState.isTouched && formFieldWithValidityState.isValid) {
            return defaultClassName+" is-valid";
        } else if (formFieldWithValidityState.isTouched && !formFieldWithValidityState.isValid) {
            return defaultClassName+" is-invalid";
        }
        return defaultClassName;
    }

    generateClassNameWithValidityForFormFieldWithUniqueAndValidState(defaultClassName, formFieldWithValidityState) {
        if (formFieldWithValidityState.isTouched && formFieldWithValidityState.isValid && formFieldWithValidityState.isUnique) {
            return defaultClassName+" is-valid";
        } else if (formFieldWithValidityState.isTouched && (!formFieldWithValidityState.isValid || !formFieldWithValidityState.isUnique)) {
            return defaultClassName+" is-invalid";
        }
        return defaultClassName;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Create your Profile
                            </div>
                            <div className="card-body">
                                <form ref={this.formSubmitRef} noValidate>
                                    <div className="form-group">
                                        <label htmlFor="inputDisplayName">Display Name</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithUniqueAndValidState("input-group flex-nowrap", this.props.displayName)}>
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithUniqueAndValidState("form-control", this.props.displayName)}
                                                id="inputDisplayName"
                                                placeholder="PizzaStoreOwner33"
                                                onChange={this.handleDisplayNameChanged}
                                                required={true}
                                                pattern=".{3,12}"
                                                disabled={this.props.isSaving}
                                            />
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="addon-wrapping"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    title="Required"
                                                >
                                                    <i className="fas fa-exclamation-circle text-warning"/>
                                                </span>
                                            </div>
                                        </div>
                                        <small id="displayNameHelpBlock" className="form-text text-muted">
                                            This is how you will be identified by other users of the site.
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            {!this.props.displayName.isUnique ? "Display Name Is Already Claimed" : "Please choose a name between 2 and 12 characters long."}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputEmail">Email</label>
                                            <div className={this.generateClassNameWithValidityForFormFieldWithUniqueAndValidState("input-group flex-nowrap", this.props.email)}>
                                                <input
                                                    type="email"
                                                    className={this.generateClassNameWithValidityForFormFieldWithUniqueAndValidState("form-control", this.props.email)}
                                                    id="inputEmail"
                                                    placeholder="boss@pizzashop.com"
                                                    onChange={this.handleEmailChanged}
                                                    required={true}
                                                    disabled={this.props.isSaving}
                                                />
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required"
                                                    >
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                                </div>
                                            </div>
                                            <small id="emailHelpBlock" className="form-text text-muted">
                                                A verification email will be sent to this address.
                                            </small>
                                            <div className="valid-feedback">
                                                Looks good!
                                            </div>
                                            <div className="invalid-feedback">
                                                {!this.props.email.isUnique ? "Email already registered to a different account." : "Please enter a valid email address."}
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputPhoneNumber">Phone Number</label>
                                            <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.phoneNumber)}>
                                                <PhoneInput
                                                    className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control w-100", this.props.phoneNumber)}
                                                    placeholder="+1 (201) 867-5309"
                                                    country={"us"}
                                                    onlyCountries={["us"]}
                                                    // value={this.props.phoneNumber.currentValue}
                                                    onChange={this.handlePhoneNumberChanged}
                                                    inputProps={{
                                                        id: "inputPhoneNumber",
                                                        pattern: ".{17}", //TODO - this will have to change if we add other countries
                                                        required: true,
                                                        className: this.generateClassNameWithValidityForFormFieldWithValidState("form-control w-100", this.props.phoneNumber),
                                                        disabled: this.props.isSaving
                                                    }}
                                                    disabled={this.props.isSaving}
                                                />
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required"
                                                    >
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                                </div>
                                            </div>
                                            <small id="phoneNumberHelpBlock" className="form-text text-muted">
                                                A verification text message will be sent to this number. Standard message and data rates apply.
                                            </small>
                                            <div className="valid-feedback">
                                                Looks good!
                                            </div>
                                            <div className="invalid-feedback">
                                                Please enter a valid phone number.
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.generateClassNameWithValidityForFormFieldWithValidState("form-group", this.props.about)}>
                                        <label htmlFor="inputAbout">About You</label>
                                        <textarea
                                            className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.about)}
                                            id="inputAbout"
                                            rows="10"
                                            onChange={this.handleAboutChanged}
                                            disabled={this.props.isSaving}
                                        />
                                        <small id="aboutHelpBlock" className="form-text text-muted">
                                            What would you like Buyer/Sellers to know about you?
                                        </small>
                                    </div>
                                    <div className={this.generateClassNameWithValidityForFormFieldWithValidState("form-group", this.props.paymentAddressName)}>
                                        <label htmlFor="inputPaymentName">Payment Name</label>
                                        <div className="input-group flex-nowrap">
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.paymentAddressName)}
                                                id="inputPaymentName"
                                                placeholder="Sarah T. Miller"
                                                onChange={this.handlePaymentAddressNameChanged}
                                                required={true}
                                                pattern=".{3,56}"
                                                disabled={this.props.isSaving}
                                            />
                                            <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required"
                                                    >
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                            </div>
                                        </div>
                                        <small id="paymentNameHelpBlock" className="form-text text-muted">
                                            What name should we use to send you payments? Your legal name or a company name.
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            Please choose a name between 2 and 12 characters long.
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="inputPaymentAddress">Payment Address</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.currentPaymentAddressGooglePlaceId)} >
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.currentPaymentAddressGooglePlaceId)}
                                                id="inputPaymentAddress"
                                                placeholder={this.props.googleAPILibReady ? "123 Sesame Street, Kings Park, NY, USA" : "Loading Google API"}
                                                required={true}
                                                readOnly={!this.props.googleAPILibReady}
                                                pattern="[0-9]+((?:(?!\n)\s)[\w]+)+(,((?:(?!\n)\s)[\w]+)+){3}"
                                                disabled={this.props.isSaving}
                                                onFocus={InputHelpers.onFocusBrowserAutoFillDisabled}
                                            />
                                            <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                        data-toggle="tooltip"
                                                        data-placement="bottom"
                                                        title="Required"
                                                    >
                                                        <i className="fas fa-exclamation-circle text-warning"/>
                                                    </span>
                                            </div>
                                        </div>
                                        <div className="invalid-feedback">
                                            Please choose an address with a number, a street (route), a city, a state, and a country.
                                        </div>
                                        <small id="paymentAddressHelpBlock" className="form-text text-muted">
                                            What address can we mail you payments to? Selecting your address from the autocomplete will fill the fields below.
                                        </small>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputStreetNumber">Street Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputStreetNumber"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressStreetNumber}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputRoute">Route</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputRoute"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressRoute}
                                            />
                                        </div>
                                    </div>
                                    <div className={this.generateClassNameWithValidityForFormFieldWithValidState("form-group", this.props.currentPaymentAddressSecondaryAddress)} >
                                        <label htmlFor="inputPaymentSecondaryAddress">Secondary</label>
                                        <input
                                            type="text"
                                            className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.currentPaymentAddressSecondaryAddress)}
                                            id="inputPaymentSecondaryAddress"
                                            placeholder="Apartment #2"
                                            onChange={this.handleCurrentPaymentAddressSecondaryAddressChanged}
                                            disabled={this.props.isSaving}
                                        />
                                        <small id="paymentSecondaryAddressHelpBlock" className="form-text text-muted">
                                            If you have an apartment or suite number, please add it here.
                                        </small>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputCity">City</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputCity"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressLocality}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputState">State</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputState"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressAdministrativeAreaLevel1}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputCountry">Country</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputCountry"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressCountryLong}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="inputPostalCode">Zip</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="inputPostalCode"
                                                readOnly={true}
                                                value={this.props.currentPaymentAddressPostalCode}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className={this.everythingIsValid() ? "btn btn-primary" : "btn btn-danger"}
                                        onClick={this.handleFormSubmit}
                                        disabled={this.props.isSaving || !this.everythingIsValid()}
                                    >
                                        {
                                            this.props.isSaving ?
                                                (
                                                    <span>
                                                        <span className="spinner-border spinner-border-sm mr-2"/>
                                                        Saving
                                                    </span>
                                                ) :
                                                "Submit"
                                        }
                                    </button>
                                    <span className="ml-2">
                                        {
                                            !this.everythingIsValid() ?
                                                (
                                                    <span className="alert alert-danger">
                                                        <i className="fas fa-exclamation-triangle mr-2"/>
                                                        Please fill out all required fields and correct any validation errors before proceeding.
                                                    </span>
                                                ):
                                                null
                                        }
                                    </span>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default ProfileCreateView;